import YoutubeManager from './YoutubeManager';
import EventsManager from '../events/EventsManager';
import CustomEvents from '../events/CustomEvents';

import VideoPlayer from './VideoPlayer';

/**
 *  YOUTUBE
 *  PLAYER
 *
 *  v1.0
 */

class YoutubePlayer {

  constructor(el, playerID, ytID, options = {}) {

    // bindings
    this.onPlayerReady = this.onPlayerReady.bind(this);
    this.onPlayerStateChange = this.onPlayerStateChange.bind(this);
    this.onCreatePlayer = this.onCreatePlayer.bind(this);
    this.onClickPoster = this.onClickPoster.bind(this);
    this.addListeners = this.addListeners.bind(this);
    this.pause = this.pause.bind(this);
    this.play = this.play.bind(this);
    this.mute = this.mute.bind(this);
    this.unMute = this.unMute.bind(this);
    this.onEnd = this.onEnd.bind(this);
    this.clearPercentCheck = this.clearPercentCheck.bind(this);
    this.checkVolume = this.checkVolume.bind(this);
    this.clearCheckVolume = this.clearCheckVolume.bind(this);

    //getting DOM elements
    this.playerContainer = el;
    this.playerEl = this.playerContainer.querySelector(".player");
    this.poster = this.playerContainer.querySelector('.poster');
    this.videoPoster = this.playerContainer.querySelector('.video-poster')

    if (this.videoPoster) {
      this.videoPosterPlayer = new VideoPlayer(this.videoPoster, 'id', {});
    }

    //defaults options
    const defaults = {
      autoplay: false,
      loop: false,
      mute: false,
      playsinline: 1,
      poster: false,
      tracking: false,
      controls: 2
    };

    //getting properties
    this.ytID = this.youtubeParser(ytID);
    this.id = playerID;

    //setting options properties
    this.options = {...defaults, ...options};
    this.hasControls = this.options.controls ? 1 : 0; // Youtube options 0 is false and 1 is true
    this.hasAutoplay = this.options.autoplay ? 1 : 0; // Youtube options 0 is false and 1 is true
    this.hasLoop = this.options.loop;
    this.muted = this.options.mute;
    this.hasPoster = this.hasAutoplay === 1 ? false : this.poster; // if player has autoplay enable we disable poster
    this.hasTracking = this.options.tracking
    this.hasPlayInline = this.options.playsinline ? 1 : 0; // Youtube options 0 is false and 1 is true

    //setting player properties
    this.done = false;
    this.canCreatePlayer = false;
    this.checkPercentView = null;
    this.checkSoundInterval = null;

    this.playerVolume = this.muted ? 0 : 1;

    this.playerInfos = {
      id: this.id,
      isPlaying: false,
      isLoaded: false,
      isMuted: this.muted,
      tracking: 0
    }

    // //hide poster if poster optioms is desabled
    // if(this.poster && !this.hasPoster)
    // 	this.poster.style.display = "none";

    // wait for the API TO BE READY
    this.canCreatePlayer = setInterval(() => {
      if (window.YT && window.YT.loaded) {
        this.onCreatePlayer();
      }
    }, 200);
  }

  /**
   * onCreatePlayer
   * This function creates an <iframe> (and YouTube player)
   * after the API code downloads.
   */

  onCreatePlayer() {
    clearInterval(this.canCreatePlayer);

    this.YTPlayer = new YT.Player(this.playerEl, {
      height: '390',
      width: '640',
      videoId: this.ytID,
      playerVars: {
        rel: 0,
        controls: this.hasControls,
        disablekb: 0,
        showinfo: 0,
        modestbranding: 0,
        autoplay: this.hasAutoplay,
        playsinline: this.hasPlayInline,
        cc_load_policy: 0,
        iv_load_policy: 3
      },
      events: {
        'onReady': this.onPlayerReady,
        'onStateChange': this.onPlayerStateChange
      }
    });
  }

  /**
   * onPlayerReady
   *
   * The API will call this function when the video player is ready.
   */

  onPlayerReady(event) {

    //Bind player To YoutubeManager
    YoutubeManager.bind(this.id, this)

    //Add required listeners
    this.addListeners();

    //unmute video on play
    if (this.muted) {
      event.target.mute();
      this.YTPlayer.setVolume(0)
    }

    if (this.videoPosterPlayer) {
      this.videoPosterPlayer.play();
    }

    this.playerInfos.isLoaded = true;

    EventsManager.broadcast(CustomEvents.youtube.LOADED, this.playerInfos);
  }


  /**
   * onPlayerStateChange
   *
   * The API calls this function when the player's state changes.
   * The function indicates that when playing a video (state=1),
   * the player should play for six seconds and then stop.
   *
   */

  onPlayerStateChange(event) {

    // pause event
    if (event.data === YT.PlayerState.PAUSED) {


      this.playerInfos.isPlaying = false;

      //stop tracking if it is present
      if (this.hasTracking) {
        this.clearPercentCheck();
      }

      this.clearCheckVolume();

      EventsManager.broadcast(CustomEvents.youtube.PAUSE, this.playerInfos);
    }

    //play event
    if (event.data === YT.PlayerState.PLAYING && !this.done) {

      //pause players expect the one playing
      YoutubeManager.pauseAllPlayersExceptOneIsPlaying(this.id);

      EventsManager.broadcast(CustomEvents.youtube.PLAY, this.playerInfos);

      this.checkVolume();
    }

    // end event
    if (event.data === YT.PlayerState.ENDED) {
      this.done = true;

      //stop player
      this.stop();
      this.onEnd();

      //if loop is true we replay the video, else we display the poster
      if (this.hasLoop && this.YTPlayer) {
        this.YTPlayer.playVideo();
      } else {
        //if(this.hasPoster)
        this.displayPoster();
      }
    }
  }

  /**
   * addListeners
   *
   */

  addListeners() {
    if (this.hasPoster && this.poster) {
      // this.poster.addEventListener("click", this.onClickPoster);
    }
  }

  /**
   * onClickPoster
   *
   */

  onClickPoster() {
    //manually trigger play on click poster
    this.hidePoster();
    this.play();
  }


  /**
   * Poster Methods
   */

  hidePoster() {
    this.playerContainer.classList.add('is-playing');

    if (this.videoPosterPlayer) {
      this.videoPosterPlayer.pause();
    }
  }

  displayPoster() {
    this.playerContainer.classList.remove('is-playing');

    if (this.videoPosterPlayer) {
      this.videoPosterPlayer.play();
    }
  }

  /**
   * Play, pause, stop, end methods
   */

  play() {
    //play Method to manually play video player
    //stop all other player
    if (this.YTPlayer) {
      this.playerInfos.isPlaying = true;
      //this.YTPlayer.unMute();
      this.YTPlayer.playVideo();

      if (this.poster) {
        this.hidePoster()
      }
    }
  }

  pause() {
    //pause method to manually pause a player
    this.YTPlayer.pauseVideo();
    this.playerInfos.isPlaying = false;
  }

  stop() {
    //stop method to mannually stop player

    //if tracking we clear the percent tracker
    this.playerInfos.isPlaying = false;

    if (this.hasTracking) {
      this.clearPercentCheck();
    }

    // reboot video
    if(this.YTPlayer) {
      this.YTPlayer.seekTo(0);
      this.YTPlayer.stopVideo();
    }

    // display poster if not loop
    if (!this.hasLoop && this.hasPoster && this.poster) {
      this.displayPoster();
    }

    // this.YTPlayer.seekTo(0); tiggers play event in onPlayerStateChange method
    //so we prevent player to trigger that event
    setTimeout(() => {
      this.done = false;
    }, 200);

    EventsManager.broadcast(CustomEvents.youtube.STOP, this.playerInfos);
  }

  /**
   * CHECK TOGGLE SOUND
   */

  checkVolume() {
    this.checkSoundInterval = setInterval(() => {
      if (this.YTPlayer.isMuted() && !this.playerInfos.isMuted) {
        this.playerInfos.isMuted = true;
        EventsManager.broadcast(CustomEvents.youtube.MUTE, this.playerInfos);
      } else if (!this.YTPlayer.isMuted() && this.playerInfos.isMuted) {
        this.playerInfos.isMuted = false;
        EventsManager.broadcast(CustomEvents.youtube.MUTE, this.playerInfos);
      }
    }, 50);
  }

  clearCheckVolume() {
    clearInterval(this.checkSoundInterval);
    this.checkSoundInterval = null;
  }

  toggleMute() {
    //manually toggle sound  !!! doesn't work on iOS
    if (this.YTPlayer.isMuted()) {
      this.YTPlayer.unMute();
    } else {
      this.YTPlayer.mute();
    }

    EventsManager.broadcast(CustomEvents.youtube.MUTE, this.playerInfos);
  }

  unMute() {
    this.YTPlayer.unMute();
  }

  mute() {
    this.YTPlayer.mute();
  }

  /**
   * Tracking methods
   */

  percentViewed() {
    if (!this.checkPercentView) {
      this.checkPercentView = setInterval(() => {

        //calculate percent every seciond progress of video
        const percentView = (this.YTPlayer.getCurrentTime() / this.YTPlayer.getDuration()) * 100;

        this.savePercentView(percentView);
      }, 1000);
    }
  }


  savePercentView(percentViewRaw) {
    //if player has already reached 100% watched we don't register other values

    if (this.playerInfos.tracking === 100) {
      return;
    }

    if (percentViewRaw > 25 && percentViewRaw < 50 && this.playerInfos.tracking !== 25) {

      this.playerInfos.tracking = 25;
      EventsManager.broadcast(CustomEvents.youtube.TRACKING, this.playerInfos);
    } else if (percentViewRaw > 50 && percentViewRaw < 75 && this.playerInfos.tracking !== 50) {

      this.playerInfos.tracking = 50;
      EventsManager.broadcast(CustomEvents.youtube.TRACKING, this.playerInfos);
    } else if (percentViewRaw > 75 && percentViewRaw < 100 && this.playerInfos.tracking !== 75) {

      this.playerInfos.tracking = 75;
      EventsManager.broadcast(CustomEvents.youtube.TRACKING, this.playerInfos);

    }

  }

  clearPercentCheck() {
    clearInterval(this.checkPercentView);
    this.checkPercentView = null;
  }

  onEnd() {
    // if ther is tracking we register 100% watched value when ENDED event is triggered
    if (this.playerInfos.tracking && this.hasTracking && this.playerInfos.tracking != 100) {
      this.playerInfos.tracking = 100;

      EventsManager.broadcast(CustomEvents.youtube.END, this.playerInfos);
    }
  }

  youtubeParser(url) {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    var match = url.match(regExp);
    return (match && match[7].length === 11) ? match[7] : url;
  }

  dispose() {
    //Removing player from window
    YoutubeManager.unbind(this.id);

    this.poster.removeEventListener("click", this.onClickPoster);

    this.YTPlayer.destroy();

    this.player = null;

    this.onPlayerReady =
    this.onPlayerStateChange =
    this.onCreatePlayer =
    this.onClickPoster =
    this.pause =
    this.play =
    this.addListeners =
    this.onEnd =
    this.checkVolume =
    this.clearPercentCheck = null;

    this.playerContainer =
    this.playerEl =
    this.poster = null;

    this.checkSoundInterval = null;

    this.ytID =
    this.id = null;

    this.options =
    this.hasAutoplay =
    this.hasLoop =
    this.muted =
    this.hasPoster =
    this.hasTracking = null;

    this.done =
    this.isPlaying =
    this.canCreatePlayer =
    this.checkPercentView = null;
  }
}

export default YoutubePlayer;
